// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen {
  :host {
    --font-size: 20px;
    --height: 15rem;
    margin-left: calc(var(--font-size) / 4);
    margin-right: calc(var(--font-size) / 4);
    width: 100%;
  }

  header {
    font-size: var(--font-size);
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  header > div {
    height: 100%;
  }

  header, main {
    color: rgb(77, 79, 93);
    font-family: "Source Sans Pro", sans-serif;
    height: 50%;
  }

  main {
    font-size: calc(var(--font-size) * 2.5);
    font-weight: bold;
    line-height: calc(var(--font-size) * 2.5);
    padding-top: 2.5rem;
  }

  section {
    background-color: rgb(255, 255, 255);
    height: var(--height);
    padding: 1rem 1rem;
  }

  .highlight {
    background-color: rgb(245, 246, 250);
  }

  .icon-arrow {
    /*background: rgb(189, 194, 198);*/
    /*border-radius: 6px;*/
    /*height: 3px;*/
    margin-left: 1rem;
    position: relative;
    top: 15px;
    width: 60px;
  }

  .icon-arrow, .icon-arrow:after, .icon-arrow:before {
    background-color: rgb(189, 194, 198);
    border-radius: 6px;
    height: 4px;
  }

  .icon-arrow:after, .icon-arrow:before {
    content: "";
    display: inline-block;
    position: absolute;
    width: 15px;
  }

  .icon-arrow:after {
    bottom: 4px;
    right: -4px;
    transform: rotate(45deg);
  }

  .icon-arrow:before {
    bottom: -4px;
    right: -4px;
    transform: rotate(-45deg);
  }

  .label {
    max-width: 75%;
  }
}

@media screen and (min-width: 1250px) {
  :host {
    --height: 12rem;
  }

  main {
    padding-top: calc(var(--height) / 10);
  }
}

@media screen and (min-width: 1521px) {
  :host {
    --height: 10rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/information-panels/statistic-block/statistic-block.component.css"],"names":[],"mappings":"AAAA;EACE;IACE,iBAAiB;IACjB,eAAe;IACf,uCAAuC;IACvC,wCAAwC;IACxC,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,0CAA0C;IAC1C,WAAW;EACb;;EAEA;IACE,uCAAuC;IACvC,iBAAiB;IACjB,yCAAyC;IACzC,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;IAClC,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;IACX,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["@media screen {\n  :host {\n    --font-size: 20px;\n    --height: 15rem;\n    margin-left: calc(var(--font-size) / 4);\n    margin-right: calc(var(--font-size) / 4);\n    width: 100%;\n  }\n\n  header {\n    font-size: var(--font-size);\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n  }\n\n  header > div {\n    height: 100%;\n  }\n\n  header, main {\n    color: rgb(77, 79, 93);\n    font-family: \"Source Sans Pro\", sans-serif;\n    height: 50%;\n  }\n\n  main {\n    font-size: calc(var(--font-size) * 2.5);\n    font-weight: bold;\n    line-height: calc(var(--font-size) * 2.5);\n    padding-top: 2.5rem;\n  }\n\n  section {\n    background-color: rgb(255, 255, 255);\n    height: var(--height);\n    padding: 1rem 1rem;\n  }\n\n  .highlight {\n    background-color: rgb(245, 246, 250);\n  }\n\n  .icon-arrow {\n    /*background: rgb(189, 194, 198);*/\n    /*border-radius: 6px;*/\n    /*height: 3px;*/\n    margin-left: 1rem;\n    position: relative;\n    top: 15px;\n    width: 60px;\n  }\n\n  .icon-arrow, .icon-arrow:after, .icon-arrow:before {\n    background-color: rgb(189, 194, 198);\n    border-radius: 6px;\n    height: 4px;\n  }\n\n  .icon-arrow:after, .icon-arrow:before {\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    width: 15px;\n  }\n\n  .icon-arrow:after {\n    bottom: 4px;\n    right: -4px;\n    transform: rotate(45deg);\n  }\n\n  .icon-arrow:before {\n    bottom: -4px;\n    right: -4px;\n    transform: rotate(-45deg);\n  }\n\n  .label {\n    max-width: 75%;\n  }\n}\n\n@media screen and (min-width: 1250px) {\n  :host {\n    --height: 12rem;\n  }\n\n  main {\n    padding-top: calc(var(--height) / 10);\n  }\n}\n\n@media screen and (min-width: 1521px) {\n  :host {\n    --height: 10rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
